var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.31 22.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#9d9c9c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "appointment-types__type-svg-fill",
    x: 17.81,
    y: 4.39,
    width: 20,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.7,7.84A3.92,3.92,0,1,0,7.78,3.92,3.93,3.93,0,0,0,11.7,7.84Zm0-6.54A2.62,2.62,0,1,1,9.08,3.92,2.62,2.62,0,0,1,11.7,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.66,4.19H17.43a.65.65,0,0,0-.65.65V9.91H14a.66.66,0,0,0-.54.3L11.7,13,9.94,10.21a.67.67,0,0,0-.55-.3H5.74a3.17,3.17,0,0,0-3.17,3.16v7a.25.25,0,0,0,0,.07,2.88,2.88,0,0,0,.5,1.38H.65a.65.65,0,1,0,0,1.29H20.14a.65.65,0,1,0,0-1.29H12.69a2.36,2.36,0,0,0,.23-1.13,2.43,2.43,0,0,0-2.48-2.26H7.58V15.6a.65.65,0,1,0-1.3,0v3.21a.65.65,0,0,0,.65.65l.07,0,.07,0h3.37a1.15,1.15,0,0,1,1.18,1,.92.92,0,0,1-.23.7,1.37,1.37,0,0,1-1,.36H5.53a1.67,1.67,0,0,1-1.66-1.67v-6.8a1.87,1.87,0,0,1,1.87-1.87H9l2.12,3.29a.66.66,0,0,0,.54.3.67.67,0,0,0,.55-.3l2.12-3.29h2.41v7.21a.65.65,0,0,0,.65.65h7.93v2.48h-2a.65.65,0,0,0,0,1.29h8.4a.65.65,0,1,0,0-1.29h-2V19.07h7.93a.65.65,0,0,0,.65-.65V4.84A.65.65,0,0,0,37.66,4.19ZM28.43,21.55H26.66V19.07h1.77ZM37,17.77H18.08V5.48H37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskScreen);
export default __webpack_public_path__ + "static/media/desk_screen.85cd3f26ab8600562183b3b23e26f039.svg";
export { ForwardRef as ReactComponent };